import React, { Component } from 'react';

class NotFoundPage extends Component<any, any> {
  render() {
    return (
      <div className='container'>
        <h2 className='headline-4' data-testid='title'>
          ページが見つかりませんでした。
        </h2>
      </div>
    );
  }
}

export default NotFoundPage;
